import { Component } from '@angular/core';
import { RouterLink } from '@angular/router';

@Component({
	selector: 'app-public-header-cta',
	templateUrl: './public-header-cta.component.html',
	styleUrls: ['./public-header-cta.component.scss'],
	imports: [RouterLink]
})
export class PublicHeaderCtaComponent {
}
